const LoginStatus = {
    NotLogged: "NotLogged",
    ChangePasswordRequired: "ChangePasswordRequired",
    NoSecurityQuestions: "NoSecurityQuestions",
    TermsOfUseNotAccepted: "TermsOfUseNotAccepted",
    LocationNotAccessed: "LocationNotAccessed",
    LocationAccessed: "LocationAccessed",
    EmailNotConfirmed: "EmailNotConfirmed"
}

const ViewRequirements = {
    NotLogged: [LoginStatus.NotLogged],
    ChangePasswordRequired: [LoginStatus.ChangePasswordRequired],
    NoSecurityQuestions: [LoginStatus.NoSecurityQuestions],
    TermsOfUseNotAccepted: [LoginStatus.TermsOfUseNotAccepted],
    LocationNotAccessed: [LoginStatus.LocationNotAccessed],
    Logged: [LoginStatus.LocationNotAccessed, LoginStatus.LocationAccessed],
    LocationAccessed: [LoginStatus.LocationAccessed]
}

const RouteNames = {
    Forbidden: "Forbidden",
    NotFound: "NotFound"
}

const Areas = {
    Accounts: "accounts",
    Settings: "settings"
}

export {LoginStatus, ViewRequirements, RouteNames, Areas}
